import { CustomerBackend } from "src/app/backend/api/customer.backend";
import { MemberBackend } from "src/app/backend/api/member.backend";
import { PetBackend } from "src/app/backend/api/pet.backend";
import { PrescriptionBackend } from "src/app/backend/api/prescription.backend";
import { Customer } from "src/app/backend/models/customer/customer";
import { Pet } from "src/app/backend/models/pet/pet";
import { PrescriptionCreate } from "src/app/backend/models/prescription/prescription";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { PopupService } from "src/app/services/popup/popup.service";
import { ApplicationRef } from "@angular/core";
import { TabService } from "src/app/services/tab.service";
import { routes } from "src/app/routing/routes";
import { pickBy } from "lodash";
import { lastValueFrom } from "rxjs";

export async function createNewPrescriptionFunction(providers: {
  tabService: TabService;
  applicationRef: ApplicationRef;
  prescriptionBackend: PrescriptionBackend;
  memberBackend: MemberBackend;
  customerBackend: CustomerBackend;
  patientBackend: PetBackend;
  popupService: PopupService;
  bootstrapService: BootstrapService;
}): Promise<void> {
  await createNewPrescriptionFunctionWithCustomerAndPatient(
    undefined,
    undefined,
    providers
  );
}

export async function createNewPrescriptionFunctionWithCustomerAndPatient(
  customer: Customer | undefined,
  patient: Pet | undefined,
  providers: {
    tabService: TabService;
    applicationRef: ApplicationRef;
    prescriptionBackend: PrescriptionBackend;
    memberBackend: MemberBackend;
    customerBackend: CustomerBackend;
    patientBackend: PetBackend;
    popupService: PopupService;
    bootstrapService: BootstrapService;
  },
  options?: {
    fromVisit: string | undefined;
  }
): Promise<void> {
  const member = providers.bootstrapService.getCurrentMember()!;

  const prescriptionCreate: PrescriptionCreate = {
    physician: {
      id: member.id,
      firstName: member.firstName,
      lastName: member.lastName
    }
  };

  if (customer) {
    prescriptionCreate.customer = {
      id: customer.id,
      firstName: customer.firstName,
      lastName: customer.lastName,
      businessName: customer.businessName,
      withoutSsn: customer.withoutSsn,
      ssn: customer.ssn
    };
  }

  if (patient) {
    prescriptionCreate.patient = {
      id: patient.id,
      name: patient.name,
      species: patient.species,
      breed: patient.breed,
      sex: patient.sex,
      microchip: patient.microchip
    };
  }

  const prescription = await lastValueFrom(
    providers.prescriptionBackend.create(prescriptionCreate)
  );

  await providers.tabService.open(
    routes.organization.prescriptions.edit(prescription.id),
    {
      params: pickBy({
        fromVisit: options?.fromVisit
      })
    }
  );
}
